export function basename(path: string) {
  return path.split("/").reverse()[0]
}
